import { Field, reduxForm } from "redux-form";
import { Button, Input } from "expano-components";
import { Modal, Select } from "components";
import useUpdate from "hooks/useUpdate";
import weekdays_options from "utils/select_options/weekdays_options";
import channel_campaign_group_sales_period_type_options from "utils/select_options/channel_campaign_group_sales_period_type_options";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;
const MultiSelectField = (props) => <Select isMulti {...props} />;

const EditSalesPeriodModal = ({
  id,
  refetch,
  handleSubmit,
  change,
  pristine,
  invalid,
  handleClose,
  initialValues,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/channel_sales_periods/${id}`,
    onSuccess: () => [refetch(), handleClose()],
  });

  const onSubmit = (values) => update(values);

  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        title: "Aktualizuj okres sprzedaży",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="save"
            disabled={is_updating || pristine || invalid}
            text="Zapisz"
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Field
          name="days_of_week"
          label="Dni tygodnia"
          component={MultiSelectField}
          options={weekdays_options}
          handleChange={(values) => change("days_of_week", values)}
          defaultValue={weekdays_options.filter(({ value }) =>
            initialValues.days_of_week.includes(Number(value)),
          )}
        />
        <div className="row m-b-20">
          <div className="box-6">
            <Field
              name="start_time"
              label="Godzina rozpoczęcia"
              component={InputField}
              type="text"
              placeholder="HH:mm"
            />
          </div>
          <div className="box-6">
            <Field
              name="end_time"
              label="Godzina zakończenia"
              component={InputField}
              type="text"
              placeholder="HH:mm"
            />
          </div>
        </div>
        <div className="row m-b-20">
          <div className="box-6">
            <Field
              name="period_type"
              label="Typ"
              component={SelectField}
              options={channel_campaign_group_sales_period_type_options}
              handleChange={(value) => change("period_type", value)}
              defaultValue={channel_campaign_group_sales_period_type_options.find(
                ({ value }) => value === initialValues.period_type,
              )}
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};

  const timeRegex = /^([01]\d|2[0-3]):(00|30)$/;

  if (!values.days_of_week || values.days_of_week.length < 1) {
    errors.days_of_week = "Dni tygodnia są wymagane!";
  }
  if (!values.period_type) {
    errors.period_type = "Typ jest wymagany!";
  }

  if (!values.start_time) {
    errors.start_time = "Godzina rozpoczęcia jest wymagana!";
  } else if (!timeRegex.test(values.start_time)) {
    errors.start_time = "Niepoprawny format. Dozwolone tylko HH:00 lub HH:30";
  }

  if (!values.end_time) {
    errors.end_time = "Godzina zakończenia jest wymagana!";
  } else if (!timeRegex.test(values.end_time)) {
    errors.end_time = "Niepoprawny format. Dozwolone tylko HH:00 lub HH:30";
  }

  if (timeRegex.test(values.start_time) && timeRegex.test(values.end_time)) {
    const [startH, startM] = values.start_time.split(":").map(Number);
    const [endH, endM] = values.end_time.split(":").map(Number);

    const startInMinutes = startH * 60 + startM;
    const endInMinutes = endH * 60 + endM;

    if (endInMinutes <= startInMinutes) {
      errors.end_time =
        "Godzina zakończenia musi być późniejsza niż rozpoczęcia!";
    }
  }

  return errors;
};

export default reduxForm({
  form: "update-channel-sales-period",
  enableReinitialize: true,
  validate,
})(EditSalesPeriodModal);
